<ion-content [scrollEvents]="true" [scrollY]="true" class="menu-sidebar transition" color="light-black">
  <ion-list lines="none" style="margin-top: 25px" class="ion-color-bg-light-black ion-no-padding">
    <ion-menu-toggle auto-hide="false">
      <ion-item class="menu-lat-header-logo">
        <img alt="CSI" slot="start" src="assets/imgs/logo/csi/CSI_Logotipo_Color.png" draggable="false" />
        <!-- <ion-label class="menu-lat-header-text">Quantum</ion-label> -->
        <ion-button slot="end" fill="clear" class="close" color="tech-blue" (click)="onClose()">
          <ion-icon slot="icon-only" mode="md" name="close-outline" size="large" style="--ionicon-stroke-width: 20px">
          </ion-icon>
        </ion-button>
      </ion-item>
    </ion-menu-toggle>

    <ion-item lines="none" class="menu-item">
      <!-- <img src="assets/imgs/logo-quantum.png" slot="start" width="36" /> -->
      <!-- <ion-icon slot="start" name="aperture-outline"></ion-icon>
      <p >Quantum</p> -->
      <img alt="Quantum" class="quantum-logo" slot="start" src="assets/imgs/logo/emblema/Quantum-Emblema-blue.png"
        draggable="false" />
      <ion-label class="vertical-center-box">
        <img alt="Quantum" style="width: 70%; display: block !important;" class="" slot="start" src="assets/imgs/logo/wordmark/Quantum-Wordmark-Blue.png"
          draggable="false" />
      </ion-label>
      <!-- <i slot="end" class="arrow" [ngClass]="showQuantumMenu ? 'arrow-down' : 'arrow-right'"></i> -->
      <i slot="end" class="arrow arrow-down"></i>
    </ion-item>

    <div class="submenu-list" #submenuElem>
      @if (showHome) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="home-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'home-item' ? 'active' : null" (click)="goToHome()">
          <ion-icon slot="start" name="home"></ion-icon>
          <p>{{ "Menu._Home" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      <!-- Dashboards - INICIO -->
      @if (dashboardFinancieroActive) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="dashboard-financiero-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'dashboard-item' &&currentDashboard === 'financiero'? 'active': null"
          (click)="goToDashboardFinanciero()">
          <ion-icon name="bar-chart-outline" slot="start"></ion-icon>
          <p>{{ "Menu.Dashboard._Financiero" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (dashboardOperativoActive) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="dashboard-operativo-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'dashboard-item' &&currentDashboard === 'operativo'? 'active': null"
          (click)="goToDashboardOperativo()">
          <ion-icon name="bar-chart-outline" slot="start"></ion-icon>
          <p class="ion-text-nowrap">
            {{ "Menu.Dashboard._Operativo" | translate }}
          </p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (dashboardAMDF) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="dashboard-amdf-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'dashboard-item' && currentDashboard === 'amdf'? 'active': null"
          (click)="goToDashboardAMDF()">
          <ion-icon name="bar-chart-outline" slot="start"></ion-icon>
          <p class="ion-text-nowrap">
            {{ "Menu.Dashboard._AMDF" | translate }}
          </p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (dashboardMazda) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="dashboard-mazda-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'dashboard-item' &&currentDashboard === 'mazda'? 'active': null"
          (click)="goToDashboardMazda()">
          <ion-icon name="bar-chart-outline" slot="start"></ion-icon>
          <p class="ion-text-nowrap">
            {{ "Menu.Dashboard._Mazda" | translate }}
          </p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (dashboardBMW) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="dashboard-bmw-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'dashboard-item' && currentDashboard === 'bmw'? 'active': null"
          (click)="goToDashboardBMW()">
          <ion-icon name="bar-chart-outline" slot="start"></ion-icon>
          <p class="ion-text-nowrap">
            {{ "Menu.Dashboard._BMW" | translate }}
          </p>
        </ion-item>
      </ion-menu-toggle>
      }
      <!-- Dashboards - FIN -->

      <!-- BSC Dashboards - INICIO -->
      @if (dashboardBSC_CPVActive) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="dashboard-cpv-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'dashboard-bsc-item' &&dashboardBSC_CPVActive &&currentDashboardBSC === 'cpv'? 'active': null"
          (click)="goToDashboardBSCCPV()">
          <ion-icon name="file-tray-full-outline" slot="start"></ion-icon>
          <p class="ion-text-nowrap">{{ "Menu.BSC._CPV" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (dashboardBSC_CSIActive) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="dashboard-csi-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'dashboard-bsc-item' &&dashboardBSC_CSIActive &&currentDashboardBSC === 'csi'? 'active': null"
          (click)="goToDashboardBSCCSI()">
          <ion-icon name="file-tray-full-outline" slot="start"></ion-icon>
          <p class="ion-text-nowrap">{{ "Menu.BSC._CSI" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (dashboardBSC_CSIDActive) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="dashboard-csid-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'dashboard-bsc-item' &&dashboardBSC_CSIDActive &&currentDashboardBSC === 'csid'? 'active': null"
          (click)="goToDashboardBSCCSID()">
          <ion-icon name="file-tray-full-outline" slot="start"></ion-icon>
          <p class="ion-text-nowrap">{{ "Menu.BSC._CSID" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (dashboardBSC_CSIXActive) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="dashboard-csix-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'dashboard-bsc-item' &&dashboardBSC_CSIXActive &&currentDashboardBSC === 'csix'? 'active': null"
          (click)="goToDashboardBSCCSIX()">
          <ion-icon name="file-tray-full-outline" slot="start"></ion-icon>
          <p class="ion-text-nowrap">{{ "Menu.BSC._CSIX" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (dashboardBSC_SunusActive) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="dashboard-sunus-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'dashboard-bsc-item' &&dashboardBSC_SunusActive &&currentDashboardBSC === 'sunus'? 'active': null"
          (click)="goToDashboardBSCSunus()">
          <ion-icon name="file-tray-full-outline" slot="start"></ion-icon>
          <p class="ion-text-nowrap">{{ "Menu.BSC._SUNUS" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }
      <!-- BSC Dashboards - FIN -->

      @if (showInvestorRelations) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="investor-relations-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'investor-relations-item' ? 'active' : null"
          (click)="goToInvestorRelationsPage()">
          <ion-icon slot="start" name="folder-outline"></ion-icon>
          <p>{{ "Menu._Investor" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showTrackingMap) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="tracking-map-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'tracking-map-item' ? 'active' : null" (click)="goToTrackingMap()">
          <ion-icon slot="start" name="location"></ion-icon>
          <p>{{ "Menu._Rastreo" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showTravelList) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="travel-list-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'travel-list-item' ? 'active' : null" (click)="goToTravelList()">
          <ion-icon slot="start" name="list"></ion-icon>
          <p>{{ "Menu._Viajes" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      <!-- @if(showVesselTravelList) { 
       <ion-menu-toggle auto-hide="true">
        <ion-item id="vessel-travel-list-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'vessel-travel-list-item' ? 'active' : null" (click)="goToVesselTravelList()">
          <ion-icon slot="start" name="list"></ion-icon>
          <p>{{ 'Menu._Viajes_Buque' | translate }}</p>
        </ion-item>
      </ion-menu-toggle> 
      } -->

      @if (showScore) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="ratings-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'ratings-item' ? 'active' : null" (click)="goToScore()">
          <ion-icon slot="start" src="assets/imgs/icons/star.svg"></ion-icon>
          <p>{{ "Menu._Ratings" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showExchange) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="exchange-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'exchange-item' ? 'active' : null" (click)="goToExchange()">
          <ion-icon name="repeat-sharp" slot="start"></ion-icon>
          <p>{{ "Menu._Intercambios" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showShipmentRequest) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="shipment-request-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'shipment-request-item' ? 'active' : null" (click)="goToShipmentRequest()">
          <ion-icon name="car" slot="start"></ion-icon>
          <p>{{ "Menu.Mobile._Embarque" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showReport) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="report-list-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'report-list-item' ? 'active' : null" (click)="goToReports()">
          <ion-icon slot="start" name="document"></ion-icon>
          <p>{{ "Menu._Reportes" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showConsultBySiteMexico) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="consulta-cd-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'consulta-cd-item' ? 'active' : null" (click)="goToConsultBySiteMexico()">
          <ion-icon slot="start" name="business-outline"></ion-icon>
          <p>{{ "Menu._Consulta_CD" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showMultipleVinConsult) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="consulta-vin-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'consulta-vin-item' ? 'active' : null" (click)="goToMultipleVinConsult()">
          <ion-icon slot="start" name="search"></ion-icon>
          <p>{{ "Menu._Consulta_VIN" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showAssetsManager) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="assets-manager-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'assets-manager-item' ? 'active' : null" (click)="goToAssetsManagerPage()">
          <ion-icon slot="start" name="bag-outline"></ion-icon>
          <p>{{ "Menu._Assets" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showMatrizEstatusEquipo) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="matriz-estatus-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'matriz-estatus-item' ? 'active' : null" (click)="goToMatrizEstatusEquipo()">
          <ion-icon slot="start" name="bus"></ion-icon>
          <p>{{ "Menu.Mobile._Matriz" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showProgramacionCarga) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="programacion-carga-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'programacion-carga-item' ? 'active' : null" (click)="goToProgramacionCarga()">
          <ion-icon slot="start" name="compass"></ion-icon>
          <p>{{ "Menu.Mobile._Posicionamiento" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showAlertasPage) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="alarmas-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'alarmas-item' ? 'active' : null" (click)="goToAlertasPage()">
          <ion-icon slot="start" name="alert"></ion-icon>
          <p>{{ "Menu._Alertas" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showConsultaDeTractor) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="consulta-tractor-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'consulta-tractor-item' ? 'active' : null" (click)="goToConsultaDeTractor()">
          <ion-icon slot="start" name="search"></ion-icon>
          <p>{{ "Menu._Tractor" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      <!-- @if (showRateTrip) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="configuracion-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'rate-trip-item' ? 'active' : null" (click)="goToRateTrip()">
          <ion-icon slot="start" name="star"></ion-icon>
          <p>{{ "Titulo._Calificar_Viaje" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      } -->

      <!-- Quantum CIVAR Item -->
      @if (loaddedQuantumCivarMenu) {
      <ion-menu-toggle auto-hide="true">
        @for ( quantumCivarItem of quantumCivarMenu()[0].OpcionMenu; track $index; let idx = $index ) {
        <ion-item lines="none" class="menu-item civar-item"
          [ngClass]="activeMenuItem() === 'civar-item' &&currentCivarQuantumItem === quantumCivarItem.Id_Cnsc_Menu? 'active': null"
          (click)="openPage(quantumCivarItem)">
          <ion-icon slot="start" [name]="getIconNameCivarMenu(quantumCivarItem.Cve_Desc_Menu)"></ion-icon>
          <p>{{ quantumCivarItem.Cve_Desc_Menu | titlecase }}</p>
        </ion-item>
        }
      </ion-menu-toggle>
      }
      <!-- Quantum CIVAR Item -->

      @if (showPermissions) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="configuracion-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'permisos-item' ? 'active' : null" (click)="goToUserPermissions()">
          <ion-icon slot="start" name="people-circle"></ion-icon>
          <p>{{ "Menu._Permisos" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }

      @if (showConfig) {
      <ion-menu-toggle auto-hide="true">
        <ion-item lines="none" id="configuracion-item" class="menu-item"
          [ngClass]="activeMenuItem() === 'configuracion-item' ? 'active' : null" (click)="goToConfig()">
          <ion-icon slot="start" name="settings"></ion-icon>
          <p>{{ "Menu._Configuración" | translate }}</p>
        </ion-item>
      </ion-menu-toggle>
      }
    </div>

    <!-- Sub Menu de Quantum Drive -->
    @if (showDrive) {
    <ion-menu-toggle auto-hide="true">
      <ion-item lines="none" id="configuracion-item" class="menu-item" (click)="goToWebFrame()">
        <img alt="" class="quantum-logo" slot="start"
          src="assets/imgs/logo/wordmark/Quantum-Drive/Emblema/Quantum-Drive-Emblema-white.png" draggable="false" />
        <p class="lb-logo-wordmark">Drive</p>
      </ion-item>
    </ion-menu-toggle>
    }

    <!-- Sub Menu de Quantum Fleet -->
    @if (showFleet) {
    <ion-menu-toggle auto-hide="true">
      <ion-item lines="none" id="configuracion-item" class="menu-item" (click)="goToWebFrame()">
        <img alt="" class="quantum-logo" slot="start"
          src="assets/imgs/logo/wordmark/Quantum-Fleet/Emblema/Quantum-Fleet-Emblema-white.png" draggable="false" />
        <p class="lb-logo-wordmark">Fleet</p>
      </ion-item>
    </ion-menu-toggle>
    }

    <!-- Sub Menu de Quantum Ontrack -->
    @if (showOntrack) {
    <ion-menu-toggle auto-hide="true">
      <ion-item lines="none" id="configuracion-item" class="menu-item" (click)="goToWebFrame()">
        <img alt="" class="quantum-logo" slot="start"
          src="assets/imgs/logo/wordmark/Quantum-Ontrack/Emblema/Quantum-Ontrack-Emblema-white.png" draggable="false" />
        <p class="lb-logo-wordmark">Ontrack</p>
      </ion-item>
    </ion-menu-toggle>
    }

    <!-- Sub Menu de Quantum Yard -->
    @if (showYard) {
    <ion-menu-toggle auto-hide="true">
      <ion-item lines="none" id="configuracion-item" class="menu-item" (click)="goToWebFrame()">
        <img alt="" class="quantum-logo" slot="start"
          src="assets/imgs/logo/wordmark/Quantum-Yard/Emblema/Quantum-Yard-Emblema-white.png" draggable="false" />
        <p class="lb-logo-wordmark">Yard</p>
      </ion-item>
    </ion-menu-toggle>
    }

    @for (civarItem of civarMenu(); track $index; let idx = $index) {
    <ion-item lines="none" class="menu-item" (click)="toggleMenu(true, idx)">
      <ion-icon slot="start" [name]="getIconNameCivarMenu(civarItem.Cve_Desc_Menu)"></ion-icon>
      <p>{{ civarItem.Cve_Desc_Menu }}</p>
      <i slot="end" class="arrow" [ngClass]="showCivarMenu()[idx] ? 'arrow-down' : 'arrow-right'"></i>
    </ion-item>
    <div class="civar-menu" #civarElem>
      <my-menu [items]="civarItem.OpcionMenu || []" [level]="1" (submenuOpen)="resizeContainer($event, idx)">
      </my-menu>
    </div>
    }

    <ion-menu-toggle auto-hide="true">
      <ion-item lines="none" class="menu-item" (click)="logout()">
        <ion-icon slot="start" name="log-out-outline"></ion-icon>
        <p>{{ "Menu._Log_Out" | translate }}</p>
      </ion-item>
      <ion-item color="light-black" lines="none" style="height: 70px !important; --padding-bottom: 70px"></ion-item>
    </ion-menu-toggle>
  </ion-list>
</ion-content>